import { render, staticRenderFns } from "./CompletedProjects.vue?vue&type=template&id=41d7df01&scoped=true&"
import script from "./CompletedProjects.vue?vue&type=script&lang=js&"
export * from "./CompletedProjects.vue?vue&type=script&lang=js&"
import style0 from "./CompletedProjects.vue?vue&type=style&index=0&id=41d7df01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d7df01",
  null
  
)

export default component.exports